import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get, invoke, isEmpty, random, range } from 'lodash';

function getSubstitutions(environmentVariables, user, bpin, searchToken, banner, itemBpn) {
  const r = () =>
    range(3)
      .map(() => random(0, 9))
      .join('');
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_GET_V1,
      Authorization: `Bearer ${user.authToken}`,
      requestId: `${r()}${new Date().getTime()}${r()}`,
      visitorId: invoke(window, 'AB.COMMON.getCookie', 'absVisitorId'),
      url: get(window, 'location.href'),
      pageurl: get(window, 'location.href'),
      pagename: 'search',
    },
  };

  const url = formatString(environmentVariables.SNS_GET_SUBSTITUTIONS, {
    UUID: user.UUID,
    BPIN: bpin,
  });
  const params = new URLSearchParams();
  if (!isEmpty(searchToken)) {
    params.append('searchToken', searchToken);
  }
  params.append('banner', banner);
  if (itemBpn) {
    params.append('itemBpn', itemBpn);
  }
  // TODO: check what is the query param for the don't substitute scenario

  return snsAxiosClient(options).get(`${url}`, {
    params,
  });
}

export default getSubstitutions;
